import React from "react";

type IncidentSeverityDisplayProps = {
    severity?: string;
    tags?: string[];
};

const severityFromTags = (tags: string[]): string | undefined => {
    if (tags.includes("high_severity"))    return "high";
    if (tags.includes("medium_severity"))  return "medium";
    if (tags.includes("low_severity"))     return "low";
    if (tags.includes("unknown_severity")) return "unknown";
    return undefined;
};

export const IncidentSeverityDisplay: React.FC<IncidentSeverityDisplayProps> = ({ severity, tags }) => {
    const effectiveSeverity = severity || (tags ? severityFromTags(tags) : undefined);

    if (!effectiveSeverity) {
        return <span className="text-grey text-sm">N/A</span>;
    }

    const getSeverityStyle = (sev: string) => {
        const lowerSeverity = sev.toLowerCase();

        if (lowerSeverity === "extreme") {
            return {
                bg: "bg-purple",
                text: "text-white",
                label: "Extreme"
            };
        }
        if (lowerSeverity === "high") {
            return {
                bg: "bg-purple",
                text: "text-white",
                label: "High"
            };
        }
        if (lowerSeverity === "major" || lowerSeverity.includes("high")) {
            return {
                bg: "bg-dark-red",
                text: "text-white",
                label: "Major"
            };
        }
        if (lowerSeverity === "medium") {
            return {
                bg: "bg-dark-orange",
                text: "text-white",
                label: "Medium"
            };
        }
        if (lowerSeverity === "moderate" || lowerSeverity.includes("medium")) {
            return {
                bg: "bg-dark-orange",
                text: "text-white",
                label: "Moderate"
            };
        }
        if (lowerSeverity === "low") {
            return {
                bg: "bg-green",
                text: "text-white",
                label: "Low"
            };
        }
        if (lowerSeverity === "limited" || lowerSeverity.includes("low")) {
            return {
                bg: "bg-[#D8B700]",
                text: "text-white",
                label: "Limited"
            };
        }
        if (lowerSeverity === "insignificant" || lowerSeverity.includes("minor")) {
            return {
                bg: "bg-green",
                text: "text-white",
                label: "Insignificant"
            };
        }
        if (lowerSeverity === "unknown") {
            return {
                bg: "bg-grey",
                text: "text-white",
                label: "Unknown"
            };
        }
        return {
            bg: "bg-grey",
            text: "text-white",
            label: sev
        };
    };

    const style = getSeverityStyle(effectiveSeverity);

    return (
        <span className={`inline-flex items-center justify-center px-2.5 py-0.5 rounded text-xs font-semibold w-24 ${style.bg} ${style.text}`}>
            {style.label}
        </span>
    );
};
